// extracted by mini-css-extract-plugin
module.exports = {"departments":"re","departmentHeading":"se","departmentSection":"te","departmentName":"ue","departmentLink":"ve","expandIcon":"we"};